export default __webpack_public_path__ + "static/media/icon (3).b5119278.png";